import React from 'react';
import './unauth-layout.styles.scss';
import UnauthHeader from './unauth-head.component';

// Signed-out pages (landing, sign-in, How it works) use the Hardwood look.
const UnauthLayout = ({ children }) => {
    return (
        <div className='unauth-layout theme-hardwood'>
            <UnauthHeader />
            <div className='g-container'>
                {children}
            </div>
        </div>
    )
}

export default UnauthLayout
